import axios from 'axios'
export default {
  changeActivation ({state, commit, rootGetters}, payload) {
    commit('changeActivation', payload.id)
    axios({
      method: 'post',
      url: process.url + 'Itens/AtivaDesativa',
      timeout: 200000,
      headers: {
        'Token': rootGetters.token
      },
      data: payload
    })
    .then((response) => {
      commit('toastr', {
        color: 'success',
        texto: 'Visibilidade alterada'
      })
    })
    .catch((error) => {
      if (error.request.response !== '') {
        var erros = JSON.parse(error.request.response).preErros
        var description = ''
        if (erros.length > 0) {
          erros.forEach(element => {
            description = description + ' ' + element
          })
        } else {
          description = erros[0]
        }
        if (erros !== undefined) {
          commit('toastr', {
            color: 'error',
            texto: description
          })
        }
      }
      commit('toggleLoadingMounted', false)
      commit('toastrAxiosError', error)
    })
  },
  getItems ({state, commit}, id) {
    commit('toggleLoadingMounted', true)
    return new Promise((resolve, reject) => {
      window.http.get('Itens/GetAll')
      .then((response) => {
        commit('toggleLoadingMounted', false)
        commit('loadRegisteredItems', response.data.resultado)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toastrAxiosError', error)
      })
    })
  },
  deleteItem ({state, commit, rootGetters}, itemId) {
    commit('toggleLoadingMounted', true)
    axios({
      method: 'post',
      url: process.url + 'Itens/Remove?id=' + itemId,
      timeout: 200000,
      headers: {
        'Token': rootGetters.token
      }
    })
    .then((response) => {
      commit('toggleLoadingMounted', false)
      commit('deleteItem', itemId)
      commit('toastr', {
        color: 'success',
        texto: 'Item deletado com sucesso'
      })
    })
    .catch((error) => {
      if (error.request.response !== '') {
        var erros = JSON.parse(error.request.response).preErros
        var description = ''
        if (erros.length > 0) {
          erros.forEach(element => {
            description = description + ' ' + element
          })
        } else {
          description = erros[0]
        }
        if (erros !== undefined) {
          commit('toastr', {
            color: 'error',
            texto: description
          })
        }
      }
      commit('toggleLoadingMounted', false)
      commit('toastrAxiosError', error)
    })
  },
  updateItem ({state, commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      // window.http.post('Itens/Salvar', queryString.stringify(JSON.stringify(state.selectedItem)))
      let form = new FormData()
      for (var key in state.selectedItem) {
        if (typeof state.selectedItem[key] === 'object') {
          form.append(key, JSON.stringify(state.selectedItem[key]))
        } else {
          form.append(key, state.selectedItem[key])
        }
      }
      form.append('Img', state.selectedItem.image)
      commit('toggleLoadingItemAction', true)
      axios({
        method: 'post',
        url: process.url + 'Itens/Salvar',
        timeout: 200000,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Token': rootGetters.token
        },
        data: form
      })
      .then((response) => {
        commit('toggleLoadingItemAction', false)
        let data = response.data
        if (data.preErros.length > 0) {
          // commit('toastrApiError', data.preErros)
          reject(data)
          commit('toastr', {
            color: 'error',
            texto: data.preErros[0]
          })
          // TODO: Integrar a api com erros[]
        } else {
          if (data.preErros.length > 0) {
            commit('toastr', {
              color: 'error',
              texto: data.preErros[0]
            })
          } else {
            if (state.selectedItem.id === '') {
              commit('appendNewItem', data.resultado)
              commit('toggleItemModal', false)
              commit('toastr', {
                color: 'success',
                texto: 'Item cadastrado com sucesso'
              })
            } else {
              commit('updateRegisteredItems', data.resultado)
              commit('toastr', {
                color: 'success',
                texto: 'Item atualizado com sucesso'
              })
            }
          }
          resolve()
        }
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingItemAction', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  selectItem ({state, commit}, id) {
    if (id === '') {
      commit('newItem')
      commit('toggleItemModal', true)
      return
    } else {
      commit('toggleLoadingMounted', true)
      return new Promise((resolve, reject) => {
        window.http.get('Itens/GetDetalhe?registro=' + id)
        .then((response) => {
          commit('toggleLoadingMounted', false)
          commit('selectItem', response.data.resultado)
          commit('toggleItemModal', true)
        })
        .catch((error) => {
          if (error.request.response !== '') {
            var erros = JSON.parse(error.request.response).preErros
            var description = ''
            if (erros.length > 0) {
              erros.forEach(element => {
                description = description + ' ' + element
              })
            } else {
              description = erros[0]
            }
            if (erros !== undefined) {
              commit('toastr', {
                color: 'error',
                texto: description
              })
            }
          }
          commit('toastrAxiosError', error)
        })
      })
    }
  },
  shelfImage ({state, commit}, value) {
    let reader = new FileReader()
    commit('updateImage', value)
    reader.onload = (e) => {
      state.imageNotSent = e.target.result
    }
    reader.readAsDataURL(value)
  },
  uploadItemImage ({state, commit, rootGetters}, image) {
    return new Promise((resolve, reject) => {
      let form = new FormData()
      form.append('cropX', state.itemVariationImage.imageCropX)
      form.append('cropY', state.itemVariationImage.imageCropY)
      form.append('cropW', state.itemVariationImage.imageCropW)
      form.append('cropH', state.itemVariationImage.imageCropH)
      form.append('image', image)
      commit('toggleLoadingItemAction', true)
      axios({
        method: 'post',
        url: process.url + 'Itens/UploadItemImage',
        timeout: 200000,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Token': rootGetters.token
        },
        data: form
      })
      .then((response) => {
        commit('toggleLoadingItemAction', false)
        let data = response.data
        if (data.preErros.length > 0) {
          reject(data)
          commit('toastr', {
            color: 'error',
            texto: data.preErros[0]
          })
          // TODO: Integrar a api com erros[]
        } else {
          commit('updateMultiPriceImage', {index: state.imgUploadIndex, value: data.resultado})
          commit('toggleImgUploadModal', false)
        }
        resolve()
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingItemAction', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  getCoupons ({state, commit}) {
    commit('toggleLoadingMounted', true)
    return new Promise((resolve, reject) => {
      window.http.get('CupomDesconto/GetListaByFornecedor?page=' + state.cupomCurrentPage + '&pageItems=' + state.cupomItemsPerPage)
      .then((response) => {
        commit('toggleLoadingMounted', false)
        commit('loadCupoms', response.data.resultado)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toastrAxiosError', error)
      })
    })
  },
  selectCupom ({state, commit}, id) {
    if (id === '') {
      commit('newCupom')
      commit('toggleCupomModal', true)
      return
    } else {
      commit('toggleLoadingMounted', true)
      return new Promise((resolve, reject) => {
        window.http.get('CupomDesconto/Get?id=' + id)
        .then((response) => {
          commit('toggleLoadingMounted', false)
          commit('selectCupom', response.data.resultado)
          commit('toggleCupomModal', true)
        })
        .catch((error) => {
          if (error.request.response !== '') {
            var erros = JSON.parse(error.request.response).preErros
            var description = ''
            if (erros.length > 0) {
              erros.forEach(element => {
                description = description + ' ' + element
              })
            } else {
              description = erros[0]
            }
            if (erros !== undefined) {
              commit('toastr', {
                color: 'error',
                texto: description
              })
            }
          }
          commit('toastrAxiosError', error)
        })
      })
    }
  },
  updateCupom ({state, commit, rootGetters}) {
    state.selectedCupom.amount = state.selectedCupom.amount / 100
    return new Promise((resolve, reject) => {
      commit('toggleLoadingCupomAction', true)
      axios({
        method: 'post',
        url: process.url + 'CupomDesconto/Save',
        timeout: 200000,
        headers: { 'Token': rootGetters.token },
        data: state.selectedCupom
      })
      .then((response) => {
        commit('toggleLoadingCupomAction', false)
        let data = response.data
        if (data.preErros.length > 0) {
          commit('toastr', {
            color: 'error',
            texto: data.preErros[0]
          })
        } else {
          if (state.selectedCupom.id === 0) {
            commit('appendNewCupom', data.resultado)
            commit('toggleCupomModal', false)
            commit('toastr', {
              color: 'success',
              texto: 'Cupom cadastrado com sucesso'
            })
          } else {
            commit('updateRegisteredCupons', data.resultado)
            commit('toastr', {
              color: 'success',
              texto: 'Cupom atualizado com sucesso'
            })
          }
        }
        resolve()
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingCupomAction', false)
        commit('toastrAxiosError', error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/item/actions.js